import React, { createContext, useContext, useState, useEffect } from 'react';
import { calculateModel, defaultInputs } from '../utils/calculations';
import { useProducts } from './ProductsContext';

const CalculatorContext = createContext();

export const useCalculator = () => {
  const context = useContext(CalculatorContext);
  if (!context) {
    throw new Error('useCalculator must be used within a CalculatorProvider');
  }
  return context;
};

export const CalculatorProvider = ({ children }) => {
  const { products } = useProducts();
  const [inputs, setInputs] = useState(defaultInputs);
  const [results, setResults] = useState(null);

  // Recalculate whenever products or inputs change
  useEffect(() => {
    const calculatedResults = calculateModel(products, inputs);
    setResults(calculatedResults);
  }, [products, inputs]);

  const updateInput = (key, value) => {
    setInputs(prev => ({
      ...prev,
      [key]: value
    }));
  };

  const updateInputs = (newInputs) => {
    setInputs(prev => ({
      ...prev,
      ...newInputs
    }));
  };

  const resetInputs = () => {
    setInputs(defaultInputs);
  };

  const value = {
    inputs,
    results,
    updateInput,
    updateInputs,
    resetInputs
  };

  return (
    <CalculatorContext.Provider value={value}>
      {children}
    </CalculatorContext.Provider>
  );
};
